import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  OrderBase,
  OrderLine,
  OrderLineResponse,
  OrderListItem,
  OrderListItemResponse,
  OrderResponse,
} from '@models/products-and-orders/orders/order.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class OrdersService {
  private readonly url = `${environment.bffUrl}/orders`;
  constructor(private httpClient: HttpClient) {}

  getAll(): Observable<OrderListItem[]> {
    return this.httpClient.get<OrderListItemResponse[]>(this.url);
  }

  getOne(id: string): Observable<OrderResponse> {
    return this.httpClient.get<OrderBase>(`${this.url}/${id}`);
  }

  getOrderLines(orderId: string): Observable<OrderLine[]> {
    return this.httpClient.get<OrderLineResponse[]>(`${this.url}/${orderId}/lines`);
  }

  getOrderLine(orderId: string, lineId: string): Observable<OrderLine> {
    return this.httpClient.get<OrderLineResponse>(`${this.url}/${orderId}/lines/${lineId}`);
  }
}
